module.exports = __webpack_public_path__ + "static/media/login-image.14d4f290.png";